import { Controller } from "@hotwired/stimulus";

// Prevents double-firing a link that loads a Turbo frame: on click it disables
// further clicks and swaps the icon for a spinner, then resets once the target
// frame finishes loading (frameId value).
export default class extends Controller {
  static targets = ["icon", "spinner"];
  static values = { frameId: { type: String, default: "invite_flyout" } };

  declare readonly hasIconTarget: boolean;
  declare readonly iconTarget: HTMLElement;
  declare readonly hasSpinnerTarget: boolean;
  declare readonly spinnerTarget: HTMLElement;
  declare readonly frameIdValue: string;

  private loading = false;
  private onFrameLoad!: (event: Event) => void;

  connect() {
    this.onFrameLoad = (event: Event) => {
      if ((event.target as HTMLElement)?.id === this.frameIdValue) this.reset();
    };
    document.addEventListener("turbo:frame-load", this.onFrameLoad);
  }

  disconnect() {
    document.removeEventListener("turbo:frame-load", this.onFrameLoad);
  }

  start(event: Event) {
    if (this.loading) {
      event.preventDefault();
      return;
    }
    this.loading = true;
    this.element.classList.add("pointer-events-none", "opacity-70");
    this.element.setAttribute("aria-busy", "true");
    this.iconTarget?.classList.add("hidden");
    this.spinnerTarget?.classList.remove("hidden");
  }

  reset() {
    this.loading = false;
    this.element.classList.remove("pointer-events-none", "opacity-70");
    this.element.removeAttribute("aria-busy");
    this.iconTarget?.classList.remove("hidden");
    this.spinnerTarget?.classList.add("hidden");
  }
}
